import React from 'react';
import PreviewQuestionShell from './PreviewQuestionShell';

const TextAreaQuestionBlock = ({ question, register, errors }) => (
    <PreviewQuestionShell question={question} error={errors[question.internalId]?.message}>
        <textarea
            className="form-control form-control-sm"
            rows={question.rows || 4}
            placeholder={question.placeholder}
            {...register(question.internalId, {
                required: question.required ? `${question.title} is required` : false,
            })}
        />
    </PreviewQuestionShell>
);

export default TextAreaQuestionBlock;
